module.exports = __webpack_public_path__ + "img/student-brief (5).ee0036fc.png";